import {computed, makeObservable} from 'mobx';
import {Collection} from '../../Common/stores/Collection';
import {SystemReportField} from './SystemReportField';

export class SystemReportCollection extends Collection {
    constructor(parent: SystemReportCollection) {
        super(parent);
        makeObservable(this);
    }

    insertFields(parentField, children, cloned?) {
        this.fields.clear();
        children.forEach(f => {
            const newField = new SystemReportField(f, parentField);
            cloned && this.updateClonedField(newField);
            newField.setCollection(f, cloned);
            this.fields.push(newField);
        });
    }

    updateClonedField(newField) {
        const lastCopy = newField.screen.lastCopy;
        newField.srvIndex = '0';
        newField.name = (Number(lastCopy.name) + 1).toString();
        newField.changed = true;
        newField.screen.lastCopy = newField;
    }

    @computed
    get firstHiddenIdx() {
        const hiddenIdx = this.fields.findIndex(field => {
            return field.isHiddenImage;
        });
        return hiddenIdx >= 0 ? hiddenIdx : this.fields.length;
    }
}
